import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { arrowRotateCwIcon, SVGIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
  ],
})
export class AuthorizeComponent implements OnInit {
  private router = inject(Router);
  private auth = inject(AuthService);

  public gettingScopes = false;
  public show = false;
  public refreshIcon: SVGIcon = arrowRotateCwIcon;

  async ngOnInit() {
    if (this.auth.isAuthenticated()) {
      if (this.auth.redirectUrl) {
        this.Refresh();
        return;
      }
    }

    //get scopes if logged in at-least
    setTimeout(() => {
      this.show = true;
    }, 2500);

    if (this.auth.isUserLoggedIn()) {
      await this.Refresh();
    }
  }

  public async Refresh() {
    try {
      this.gettingScopes = true;

      await this.auth.authorize();
      if (this.auth.redirectUrl) {
        let parts = this.auth.getRedirect();
        this.router.navigate(parts.url, parts.extras);
        this.auth.redirectUrl = null;
      }
      else if (this.router.url != '/authorize') {
        this.router.navigate([this.router.url]);
      }
      else {
        this.router.navigate(['/']);
      }
    } catch (error) {
      console.warn('Error Getting Scopes: ', error);
    }
    this.gettingScopes = false;
  }
}